import { defineComponent as _defineComponent } from 'vue'

export enum OzCenterModalScrollbarPreset {
  Regular = 'Regular',
  Thin = 'Thin',
}

const __default__ = {}

import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { nextTick, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzCenterModal',
  props: {
    windowHeight: null,
    fullSize: { type: Boolean, default: undefined },
    minHeight: { default: 0 },
    startingClickLocation: { default: undefined },
    heightClass: { default: 'h-auto' },
    widthClass: { default: 'w-180' },
    shadowClass: { default: 'shadow-z5' },
    darkMode: { type: [Boolean, String], default: 'auto' },
    shouldFadeIn: { type: Boolean, default: true },
    scrollbarPreset: { default: OzCenterModalScrollbarPreset.Regular }
  },
  emits: ['scrim-click', 'scrim-esc'],
  setup(__props: any) {

const props = __props as { windowHeight: number, fullSize: boolean, minHeight: number | string, startingClickLocation: { top: number; left: number } | undefined, heightClass: 'h-auto' | 'h-90', widthClass: 'w-180' | 'w-135' | 'w-128' | 'w-82', shadowClass: 'shadow-z5' | 'shadow-elevation-4', darkMode: boolean | 'auto', shouldFadeIn: boolean, scrollbarPreset: OzCenterModalScrollbarPreset }





const modalContainer = ref<HTMLDivElement>()
const minRenderHeight = ref('0px')

watch(
  [() => props.minHeight, () => props.fullSize],
  () => {
    // For tablet/desktop, we simply change the modal height
    nextTick(() => {
      if (props.fullSize) {
        minRenderHeight.value = props.windowHeight - 112 + 'px'
      } else {
        if (typeof props.minHeight === 'number') {
          minRenderHeight.value = props.minHeight + 'px'
        } else if (typeof props.minHeight === 'string') {
          minRenderHeight.value = props.minHeight
        }
      }
    })
  },
  { immediate: true },
)

const animateIn = (): void => {
  const modalContainerEl = modalContainer.value
  if (!props.startingClickLocation) {
    modalContainerEl.style.animationName = 'modal-fade' // animation-name: modal-fade;
    return
  }

  const centerOfScreen = {
    top: props.windowHeight / 2,
    left: window.innerWidth / 2,
  }
  const startOffset = {
    top: props.startingClickLocation.top - centerOfScreen.top,
    left: props.startingClickLocation.left - centerOfScreen.left,
  }
  const startTransformation = {
    scale: 0,
    translate3d: {
      y: startOffset.top,
      x: startOffset.left,
      z: 0,
    },
  }
  const endTransformation = {
    scale: 1,
    translate3d: { x: 0, y: 0, z: 0 },
  }

  function generateTransformString(details: {
    scale: number
    translate3d: { x: number; y: number; z: number }
  }): string {
    return `translate3d(${details.translate3d.x}px, ${details.translate3d.y}px, ${details.translate3d.z}px) scale(${details.scale}) `
  }

  modalContainerEl.style.transition = 'none'
  modalContainerEl.style.transformOrigin = 'center'
  modalContainerEl.style.transform = generateTransformString(startTransformation)
  setTimeout(() => {
    /**
     * Decelerated easing for incoming element
     * @see https://material.io/design/motion/speed.html#easing
     */
    modalContainerEl.style.transition = 'all 300ms cubic-bezier(0.0, 0.0, 0.2, 1)'
    modalContainerEl.style.transform = generateTransformString(endTransformation)
  }, 1)
}

onMounted((): void => {
  animateIn()
})

return { __sfc: true,OzCenterModalScrollbarPreset, props, modalContainer, minRenderHeight, animateIn, OzOverlay }
}

})